/* eslint-disable security/detect-object-injection */
/* eslint-disable react/function-component-definition */
import React, { Dispatch, SetStateAction, memo } from "react";

interface Props {
  title: string;
  description: string;
  supportedFileText?: string;
  className?: string;
  setFile: Dispatch<SetStateAction<File | null>>;
  acceptedFiles?: string[];
}

function UploadDocument({
  title,
  description,
  supportedFileText,
  className,
  setFile,
  acceptedFiles
}: Props) {
  const handleDragOver = (event: React.DragEvent<HTMLLabelElement>) => {
    event.preventDefault();
    event.currentTarget.classList.add("drag-over");
  };

  const handleDrop = (event: React.DragEvent<HTMLLabelElement>) => {
    event.preventDefault();
    event.currentTarget.classList.remove("drag-over");
    const dt = event.dataTransfer;
    if (dt.items) {
      for (let i = 0; i < dt.items.length; i += 1) {
        if (dt.items[i].kind === "file") {
          const droppedFile = dt.items[i].getAsFile();
          if (droppedFile) {
            setFile(droppedFile);
          }
        }
      }
    } else {
      for (let i = 0; i < dt.files.length; i += 1) {
        const droppedFile = dt.files[i];
        setFile(droppedFile);
      }
    }
  };
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      setFile(event.target.files[0]);
    }
  };

  return (
    <div
      className={`rounded-lg text-left transform transition-all min-h-[14rem] !bg-white ${className}`}
    >
      <h1 className="min-h-[1.6875rem] w-52 mx-auto mt-[35px] mb-7 text-center font-montserrat text-1.5xl font-bold">
        {title}
      </h1>

      <label
        htmlFor="file-upload"
        className="flex flex-col items-center justify-center min-h-[145px] mx-4 border-smokeGrey border-2 border-dashed rounded-lg bg-whiteSmoke px-2 py-2 text-center"
        onDragOver={handleDragOver}
        onDrop={handleDrop}
      >
        <div className="flex flex-col items-center justify-center w-39.75">
          <svg
            className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 20 16"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
            />
          </svg>

          <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
            <span className="font-semibold break-words break-all">{description}</span>
          </p>

          {supportedFileText && (
            <p className="text-xs text-gray-500 dark:text-gray-400">{supportedFileText}</p>
          )}
        </div>
        <input
          id="file-upload"
          type="file"
          accept={acceptedFiles?.join(",")}
          onChange={handleFileChange}
          className="hidden"
        />
      </label>
    </div>
  );
}

UploadDocument.defaultProps = {
  supportedFileText: "",
  className: "",
  acceptedFiles: []
};

export default memo(UploadDocument);
